import { Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ToastController } from '@ionic/angular';
import { AxovaQrCode } from 'src/app/models/axova-qr-code.class';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CapacitorBarcodeScanner } from '@capacitor/barcode-scanner';
import { CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner/dist/esm/definitions';

@Injectable({
  providedIn: 'root',
})
export class QrcodeService {
  constructor(
    private toastController: ToastController,
    private permissionsService: PermissionsService,
    private ngZone: NgZone,
  ) {
  }

  /**
   * Start the QR/App Access Code Scan.
   */
  public async startScanner(mockdataType?: 'project' | 'equipment' | 'screen' | 'eventInvitation'): Promise<AxovaQrCode | undefined> {
    return new Promise(async (resolve) => {
      if (!Capacitor.isNativePlatform()) {
        setTimeout(() => {
          switch (mockdataType) {
            case 'project':
              resolve(new AxovaQrCode('{"type":"project","data":{"id":"17655"}}'));
              break;
            case 'equipment':
              resolve(new AxovaQrCode('{"type":"equipment","data":{"id":"1999"}}'));
              break;
            case 'screen':
              resolve(new AxovaQrCode('{"type":"screendevice","data":{"uniqueIdentifier":"288c817c-8dd3-48c9-8c03-285e40ed089d"}}'));
              break;
            case 'eventInvitation':
              resolve(new AxovaQrCode('{"type":"eventInvitation","data":{"accessKey":"4c42eaa2e95a2a287e77c334b241ff75"}}'));
              break;
          }
        }, 100);
      } else {
        const hasPermissions = await this.permissionsService.checkCameraPermissions('camera');
        if (hasPermissions) {
          const result = await CapacitorBarcodeScanner.scanBarcode({ hint: CapacitorBarcodeScannerTypeHint.QR_CODE });
          this.ngZone.run(() => {
            const qrCode = new AxovaQrCode(result.ScanResult);
            if (qrCode.isValid) {
              resolve(qrCode);
            } else {
              this.showInvalidQrCodeMessage().then();
              resolve(undefined);
            }
          });
        } else {
          resolve(undefined);
        }
      }
    });
  }

  private async showInvalidQrCodeMessage() {
    const toast = await this.toastController.create({
      message: 'Dieser QR-Code ist ungültig.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }
}
